import { useContext, useEffect, useState } from 'react';

import { deleteCompany, restoreCompany } from '~/api';
import { DeleteModal, RestoreModal } from '~/components/Modals';
import { ThreeDotActionMenu } from '~/components/Shared';
import { CountryContext, UserInfoContext } from '~/context';
import { isAdmin } from '~/enums';
import { FlexLayout, Table } from '~/ui';
import { showToast } from '~/ui/components/Toast';
import { errorHandler } from '~/utils/errors';

import { getCompaniesTrashColumns, getCompaniesTrashData } from './CompaniesTrashTable.utils';

function CompaniesTrashTable({ data = [], setRefreshTrigger, isSearchable = false }) {
  const [companies, setCompanies] = useState(data);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const { userInfo } = useContext(UserInfoContext);
  const { countriesByName } = useContext(CountryContext);

  useEffect(() => {
    setCompanies(data);
  }, [data]);

  function onItemDelete() {
    deleteCompany(selectedItem.id, true)
      .then(() => {
        setCompanies((prev) => prev.filter((company) => company.id !== selectedItem.id));
        setRefreshTrigger((prev) => !prev);
        setShowDeleteModal(false);
        setSelectedItem(null);
        showToast('Company has been successfully deleted.');
      })
      .catch(errorHandler);
  }

  function onItemRestore() {
    restoreCompany(selectedItem.id)
      .then(() => {
        setCompanies((prev) => prev.filter((company) => company.id !== selectedItem.id));
        setRefreshTrigger((prev) => !prev);
        setShowRestoreModal(false);
        setSelectedItem(null);
        showToast('Company has been successfully restored.');
      })
      .catch(errorHandler);
  }

  function renderActionColumn(item) {
    if (!isAdmin(userInfo.role)) return null;

    return (
      <ThreeDotActionMenu
        options={[
          {
            label: 'Restore',
            onClick: () => {
              setShowRestoreModal(true);
              setSelectedItem(item);
            },
          },
          {
            label: 'Delete permanently',
            onClick: () => {
              setShowDeleteModal(true);
              setSelectedItem(item);
            },
          },
        ]}
      />
    );
  }

  return (
    <FlexLayout flexDirection="column">
      <Table
        actionColumn={renderActionColumn}
        columns={getCompaniesTrashColumns()}
        data={getCompaniesTrashData(companies, countriesByName || {}, userInfo)}
        isSearchable={isSearchable}
      />
      <DeleteModal
        item="company"
        isShowing={showDeleteModal}
        handleOnDeleteClick={onItemDelete}
        handleOnHide={() => {
          setShowDeleteModal(false);
          setSelectedItem(null);
        }}
        isDeletePermanent
      />
      <RestoreModal
        item="company"
        isShowing={showRestoreModal}
        handleOnRestoreClick={onItemRestore}
        handleOnHide={() => {
          setShowRestoreModal(false);
          setSelectedItem(null);
        }}
      />
    </FlexLayout>
  );
}

export default CompaniesTrashTable;
